import style from './Contacts.module.scss';
import React from "react";


type ContactsPropsType = {
  // clients: Array<ClientType>
}

const Contacts: React.FC<ContactsPropsType> = () => {

  return (
    <div className={style.contacts}>

      <div className={style.frame}>

        <div className={style.text}>
          <div className={style.items__wrapper}>
            <h2 className={style.title}>Contacts</h2>
            <div className={style.contacts__items}>
            <p className={style.value__item}>CSC El Gran Kush </p>
            <p className={style.value__item}>Adress: C. Noruega, 3, 03183 Torrevieja </p>
            <p className={style.value__item}>Phone: +34 604 449 147 </p>
            </div>
           
          </div>

        </div>

        <div className={style.map__wrapper}>
          <iframe className={style.map} src="https://storage.googleapis.com/maps-solutions-i87kudr0gr/commutes/43cp/commutes.html"
            width="100%" height="100%"

            loading="lazy">
          </iframe>
        </div>
      </div>

    </div>
  )
}

export default Contacts